// eslint-disable-next-line import/prefer-default-export
export const checkCamAndExec = ({ bool, cameraName }, fn) => (data) => {
  if (data.camera === cameraName) {
    fn(bool ? !!data : data);
  }
};
